// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__6MmOz","alertIcon":"ConfirmModal_alertIcon__1t89N"};